export default __webpack_public_path__ + "img/fr-c7b28639e5d9c9e408b95a4965962e9a.png";